export const FETCH_USER_INFO_START = 'FETCH_USER_INFO_START';
export const FETCH_USER_INFO_SUCCESS = 'FETCH_USER_INFO_SUCCESS';
export const FETCH_USER_INFO_FAILURE = 'FETCH_USER_INFO_FAILURE';

export const SET_TABLE_FIELDS_START = 'SET_TABLE_FIELDS_START';
export const SET_TABLE_FIELDS_SUCCESS = 'SET_TABLE_FIELDS_SUCCESS';
export const SET_TABLE_FIELDS_FAILURE = 'SET_TABLE_FIELDS_FAILURE';


